import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "@material-ui/core";
import Buttons from "@mui/material/Button";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SearchIcon from '@mui/icons-material/Search';
import NotificationsIcon from '@mui/icons-material/Notifications';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LanguageIcon from '@mui/icons-material/Language';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import EventIcon from '@mui/icons-material/Event';
import GroupIcon from '@mui/icons-material/Group';
import WorkIcon from '@mui/icons-material/Work';
import SettingsIcon from '@mui/icons-material/Settings';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

import "./style.css";

const SidebarItem = ({ icon, text, active }) => (
  <div className={`sidebar-item ${active ? "active" : ""}`}>
    {icon}
    <span>{text}</span>
  </div>
);

const ServiceButton = ({ label, link, onClick, icon }) => {
  const content = (
    <div className="service-btn">
      {icon ? icon : <AutoAwesomeIcon style={{ fontSize: 16, marginRight: 8, color: '#666' }} />}
      <span>{label}</span>
    </div>
  );

  if (link) {
    return (
      <Link to={link} style={{ textDecoration: "none", color: "inherit" }}>
        {content}
      </Link>
    );
  }
  return (
    <div onClick={onClick} style={{ cursor: "pointer", display: "inline-block" }}>
      {content}
    </div>
  );
};

const CategoryCard = ({ title, icon, children }) => {
  const hasChildren = React.Children.toArray(children).some(child => child);
  if (!hasChildren) return null;

  return (
    <div className="category-card">
      <div className="category-header">
        {icon}
        <h3>{title}</h3>
      </div>
      <div className="category-body">
        {children}
      </div>
    </div>
  );
};

const Home = ({
  isAuth,
  a_watchnow,
  a_events,
  a_announce,
  a_websiteAccess,
  a_education,
  a_email,
  a_startupshort,
  a_adminboard,
  a_blog,
  a_mobilenumbercleanup,
  a_user,
  a_learner,
  a_mainpage,
  a_kitpage,
  a_funding,
  a_virtualcampus,
  a_memberships,
  a_courses,
  a_updatelink,
  a_casestudy,
  a_badge,
  a_applycourses,
  a_eventcertificate,
  a_dailygoals,
  a_createcourse,
  a_analytics,
  a_events_register,
  a_events1,
  a_lab,
  a_workex,
  a_editcourse,
  a_generatelink,
  a_redeem,
  a_certificates,
  a_admincertificates,
  a_brochuredetails,
  a_workexperience,
  a_workexperienceapproval,
  a_payments,
  a_mentors,
  a_hire,
  a_scholarship,
  a_availability,
  a_queries,
  a_booking,
  a_org,
  a_review,
  a_partnerw,
  a_password,
}) => {
  const [openCreate, setOpenCreate] = useState(false);

  const createBox = (
    <div className="popup" id="popup-1">
      <div className="overlay">
        <div className="content">
          <div className="close-btn" onClick={() => setOpenCreate(false)}>
            <CloseOutlinedIcon />
          </div>
          <div className="btn_box">
            {a_email && (
              <Link to={`/emails`} style={{ textDecoration: "none" }}>
                <Buttons variant="contained" onClick={() => setOpenCreate(false)} className="email_btn1">
                  Promotional Emails
                </Buttons>
              </Link>
            )}
            <Link to={`/email`} style={{ textDecoration: "none" }}>
              <Buttons variant="contained" onClick={() => setOpenCreate(false)} className="email_btn2">
                Welcome Emails
              </Buttons>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );

  if (!isAuth) {
    return (
      <div className="login-prompt">
        <p>Please login to continue</p>
        <Link to="/login" style={{ textDecoration: "none" }}>
          <Buttons variant="contained">Login</Buttons>
        </Link>
      </div>
    );
  }

  return (
    <div className="admin-layout">
      {/* Header */}
      <div className="header">
        <div className="header-logo-section">
          <div className="sidebar-logo">
            <span className="logo-icon">M</span>
          </div>
          <div className="header-title">
            <h2>MarkoKnow Admin Panel</h2>
          </div>
        </div>
        <div className="header-search">
          <SearchIcon style={{ color: '#888' }} />
          <input type="text" placeholder="Search anything..." />
          <div className="search-shortcut">⌘ K</div>
        </div>
        <div className="header-actions">
          <div className="notification-icon">
            <NotificationsIcon />
            <span className="badge">3</span>
          </div>
          <div className="profile-btn">
            <AccountCircleIcon style={{ marginRight: 6 }} />
            <span>MARKOKNOW</span>
          </div>
        </div>
      </div>

      <div className="layout-body">
        {/* Sidebar */}
        <div className="sidebar">
          <div className="sidebar-menu">
            <SidebarItem icon={<DashboardIcon />} text="Dashboard" active />
            <SidebarItem icon={<LanguageIcon />} text="Website & Content" />
            <SidebarItem icon={<MenuBookIcon />} text="Courses & Learning" />
            <SidebarItem icon={<EventIcon />} text="Events & Certificates" />
            <SidebarItem icon={<GroupIcon />} text="Users & Students" />
            <SidebarItem icon={<WorkIcon />} text="Hiring & Applications" />
            <SidebarItem icon={<SettingsIcon />} text="Operations & Utilities" />
            <SidebarItem icon={<EmailIcon />} text="Communication" />
            <div className="sidebar-divider"></div>
            <SidebarItem icon={<SettingsIcon />} text="Settings" />
            <SidebarItem icon={<LockIcon />} text="Page Passwords" />
          </div>
          <div className="sidebar-footer-card">
            <h4><AutoAwesomeIcon style={{ fontSize: 18, marginRight: 5, verticalAlign: 'middle' }} /> Quick access to all admin tools</h4>
            <p>Manage, monitor and grow MarkoKnow seamlessly.</p>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          {/* Categories Grid */}
          <div className="categories-grid">

            <CategoryCard title="Website & Content" icon={<LanguageIcon style={{ color: '#2ecc71' }} />}>
              {a_watchnow && <ServiceButton link="/watchnow" label="Watch Now" icon={<PlayCircleOutlineIcon style={{ fontSize: 16, marginRight: 8, color: '#666' }} />} />}
              {a_mainpage && <ServiceButton link="/mainPage" label="Main Page" />}
              {a_blog && <ServiceButton link="/blog" label="Blog" />}
              {a_education && <ServiceButton link="/learn" label="Learn Page" />}
              {a_kitpage && <ServiceButton link="/KitPage" label="Kit Page" />}
              {a_casestudy && <ServiceButton link="/casestudy" label="Case Study" />}
              {a_announce && <ServiceButton link="/announcement" label="Announcements" />}
              {a_virtualcampus && <ServiceButton link="/virtualCampus" label="Virtual Campus" />}
              {a_partnerw && <ServiceButton link="/partner" label="Partner List" />}
              {a_websiteAccess && <ServiceButton link="/access" label="Website Access" />}
              {true && <ServiceButton link="/contact" label="Contact" />}
              {a_memberships && <ServiceButton link="/memberships" label="Memberships" />}
              {a_updatelink && <ServiceButton link="/updateLinks" label="Update Links" />}
            </CategoryCard>

            <CategoryCard title="Courses & Learning" icon={<MenuBookIcon style={{ color: '#3498db' }} />}>
              {a_courses && <ServiceButton link="/courses" label="Courses" />}
              {a_createcourse && <ServiceButton link="/CreateCoursePage" label="Create Course" />}
              {a_editcourse && <ServiceButton link="/aboutcources" label="Edit Courses" />}
              {a_funding && <ServiceButton link="/funding" label="Funding" />}
              {a_startupshort && <ServiceButton link="/startupshortsadmin" label="Startup Shorts Admin" />}
              {a_badge && <ServiceButton link="/badge" label="Badges" />}
              {a_learner && <ServiceButton link="/Learner_landing" label="Learner Landing Page" />}
              {a_lab && <ServiceButton link="/lab" label="Lab" />}
              {a_dailygoals && <ServiceButton link="/dailygoals" label="Daily Goal" />}
            </CategoryCard>

            <CategoryCard title="Events & Certificates" icon={<EventIcon style={{ color: '#9b59b6' }} />}>
              {a_events && <ServiceButton link="/bookevents" label="Book Events" />}
              {a_events_register && <ServiceButton link="/registeredEvents" label="Event Registrations" />}
              {a_eventcertificate && <ServiceButton link="/events/certificates" label="Event Certificate" />}
              {a_certificates && <ServiceButton link="/certificates" label="Certificates" />}
              {a_generatelink && <ServiceButton link="/checkoutlink" label="Generate Checkout Link" />}
              {a_redeem && <ServiceButton link="/redeem" label="Redeem" />}
              {a_events1 && <ServiceButton link="/events" label="Events" />}
            </CategoryCard>

            <CategoryCard title="Users & Students" icon={<GroupIcon style={{ color: '#2ecc71' }} />}>
              {a_user && <ServiceButton link="/user" label="User" />}
              {a_applycourses && <ServiceButton link="/applycourse" label="Apply Course Leads" />}
              {true && <ServiceButton link="/inActiveUsers" label="Inactive Students" />}
              {true && <ServiceButton link="/onboardingDetails" label="Onboarding Details" />}
              {a_mobilenumbercleanup && <ServiceButton link="/mobilenumbercleanup" label="Mobile Numbers Cleanup" />}
              {true && <ServiceButton link="/connectwithus" label="Markoknow Connect" />}
            </CategoryCard>

            <CategoryCard title="Hiring & Applications" icon={<WorkIcon style={{ color: '#f39c12' }} />}>
              {a_mentors && <ServiceButton link="/mentors" label="Mentor Applications" />}
              {a_hire && <ServiceButton link="/hires" label="Hiring Entries" />}
              {a_scholarship && <ServiceButton link="/scholarship" label="Scholarship Applications" />}
              {a_availability && <ServiceButton link="/availability" label="Availability for Interview" />}
              {true && <ServiceButton link="/role" label="Role Opening" />}
              {true && <ServiceButton link="/revenue" label="Revenue Exchange Leads" />}
              {true && <ServiceButton link="/capitaloffice" label="Capital Office Applications" />}
              {true && <ServiceButton link="/founderscircle" label="Founders Circle Applications" />}
              {true && <ServiceButton link="/globalexpansion" label="Global Expansion Plans" />}
              {a_org && <ServiceButton link="/org" label="Org Review" />}
              {a_review && <ServiceButton link="/orglist" label="Org Review Approval" />}
            </CategoryCard>

            <CategoryCard title="Operations & Utilities" icon={<SettingsIcon style={{ color: '#34495e' }} />}>
              {a_workexperience && <ServiceButton link="/workex" label="Work Ex" />}
              {a_workexperienceapproval && <ServiceButton link="/workex/approval" label="Work Ex Approval" />}
              {a_payments && <ServiceButton link="/payments" label="Payments Status" />}
              {a_queries && <ServiceButton link="/queries" label="Queries" />}
              {a_booking && <ServiceButton link="/bookings" label="Booking" />}
              {true && <ServiceButton link="/volunteerform" label="Volunteer List" />}
              {true && <ServiceButton link="/imageupload" label="Image Upload" />}
              {true && <ServiceButton link="/form" label="Form" />}
              {a_brochuredetails && <ServiceButton link="/brochuredetails" label="Brochure Details" />}
              {a_admincertificates && <ServiceButton link="/admin/certificates" label="Admin Certificate" />}
              {a_adminboard && <ServiceButton link="/adminboard" label="Admin Board" />}
              {a_analytics && <ServiceButton link="/analytics" label="Analytics" />}
            </CategoryCard>

            <CategoryCard title="Communication" icon={<EmailIcon style={{ color: '#9b59b6' }} />}>
              {a_announce && <ServiceButton link="/announcement" label="Announcements" />}
              {a_email && <ServiceButton onClick={() => setOpenCreate(true)} label="Email" />}
              {a_queries && <ServiceButton link="/queries" label="Queries" />}
              {true && <ServiceButton link="/contact" label="Contact" />}
            </CategoryCard>

          </div>

          {/* Footer copyright */}
          <div className="admin-footer">
            © 2025 MarkoKnow. All rights reserved.
          </div>
        </div>
      </div>

      <Modal open={openCreate} onClose={() => setOpenCreate(false)}>
        {createBox}
      </Modal>

    </div>
  );
};

export default Home;